import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { DelegateRightsRoutes } from './delegaterights.routes';
import { ListDelegateRightsComponent } from './list-delegaterights/list-delegaterights.component';
import { FormDelegateRightsComponent } from './_components/form-delegaterights/form-delegaterights.component';
import { AddDelegateRightsComponent } from './add-delegaterights/add-delegaterights.component';
import { EditDelegateRightsComponent } from './edit-delegaterights/edit-delegaterights.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [DelegateRightsRoutes, SharedDocumalisModule, TranslateModule],
    declarations: [ListDelegateRightsComponent, AddDelegateRightsComponent, EditDelegateRightsComponent, FormDelegateRightsComponent],
})
export class DelegateRightsModule {}
